import Cookies from 'js-cookie'

const TokenKey = 'token'
const UserInfoKey = 'user_info'

// token
export function getToken() {
	return Cookies.get(TokenKey)
}
export function setToken(token) {
	return Cookies.set(TokenKey, token)
}
export function removeToken() {
	return Cookies.remove(TokenKey)
}

// 用户信息
export function getUserInfo() {
	const info = Cookies.get(UserInfoKey)
	return info ? JSON.parse(info) : {}
}
export function setUserInfo(info) {
	return Cookies.set(UserInfoKey, JSON.stringify(info))
}
export function removeUserInfo() {
	return Cookies.remove(UserInfoKey)
}